import PropTypes from 'prop-types';
import React, { Component } from 'react';

const styles = {
  container: {
    padding: 10,
    textAlign: 'justify',
    fontFamily: 'Raleway',
  },
  link: {
    textDecoration: 'underline',
  },
  list: {
    fontWeight: '600',
  },
};

// eslint-disable-next-line react/prefer-stateless-function
export default class TermsOfService extends Component {
  static propTypes = {
    style: PropTypes.object,
  };

  render() {
    const { style } = this.props;
    const codeOfConductLink = (
      <a
        style={styles.link}
        href={`${process.env.APP_URL}/code-of-conduct`}
      >
        Ripple Street Code of Conduct
      </a>
    );
    const socialPactLink = (
      <a
        style={styles.link}
        href='https://www.facebook.com/notes/ripple-street/ripple-street-social-pact/489867511023866'
      >
        Social Pact
      </a>
    );
    return (
      <div style={style}>
        <div style={styles.container}>
          <p>
            <strong>What Does Disclosure Mean For Me?</strong>
          </p>
          <p>
            Whether you&apos;re a House Party host, a Chatterbox, an event applicant or even a guest, disclosure is key
            to authentic word-of-mouth, whether online or offline. Given this, we realize that you might not know a)
            exactly what &ldquo;disclosure&rdquo; is b) why it&apos;s important and c) how to make sure you&apos;re
            doing your part as a Ripple Street member when it comes to disclosure. So, that&apos;s why we&apos;ve got
            the skinny on all that for you here!
          </p>
          <p>
            <strong>What is &ldquo;Disclosure&rdquo;?</strong>
          </p>
          <p>
            &ldquo;Disclosure&rdquo; simply means telling people about something that they might not otherwise know,
            but have a right to know. An example would be telling someone that the great Party Pack you received or the
            new Chatterbox event to which you&apos;ve applied is sponsored...in these cases by us, Ripple Street!
          </p>
          <p>
            <strong>How does disclosure involve me?</strong>
          </p>
          <p>
            Simply put, disclosure involves you because word-of-mouth involves you. Being a part of the Ripple Street
            community, you help <i>power</i> word-of-mouth! (Pretty cool, huh?) Every time that you talk to someone
            about a product you got to know thanks to Ripple Street, you provide them with contextual information that
            helps them understand how you experienced the product. This way, people can trust that both your comments
            and reviews are honest and know more about from whom the opportunity was brought to you.
          </p>
          <p>
            <strong>What do I need to be doing about disclosure?</strong>
          </p>
          <p>
            Whenever you talk about a House Party or Chatterbox event brought to you by Ripple Street or the products
            they&apos;re celebrating – online or offline, you should:
          </p>
          <ol style={styles.list}>
            <li>Be honest and authentic about your opinions</li>
            <li>Use the #sponsored hashtag</li>
            <li>If you receive a Party Pack or Chat Pack, let folks know you received it for free</li>
            <li>Lastly, be sure to abide by the {codeOfConductLink} and {socialPactLink}</li>
          </ol>
          <p>
            So, that&apos;s why disclosure doesn&apos;t just involve you, it depends on you
          </p>
          <p>
            Easy enough, right? Party on, chat on and disclose on, folks!
          </p>
        </div>
      </div>
    );
  }
}
